export const getBrowserType = state => state.request.get('browser')
